import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const NewHampshire = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>New Hampshire Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Limited disclosures required; standard form provided by the New
          Hampshire Association of Realtors.
        </Text>

        <Text style={styles.listItem}>
          2. Water Supply and Sewage Disposal Disclosure: Required.
        </Text>

        <Text style={styles.listItem}>
          3. Lead Paint Disclosure: Mandatory for homes built before 1978.
        </Text>

        <Text style={styles.listItem}>
          4. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          5.{' '}
          <Text style={styles.underline}>Buyer's Notification Disclosure</Text>{' '}
          – Prior to executing a purchase closure.
        </Text>

        <Text style={styles.listItem}>
          6.{' '}
          <Text style={styles.underline}>
            Seller's Property Disclosure Statement
          </Text>{' '}
          – The seller is required to attach the property disclosure statement
          to the purchase agreement and inform the buyer of specific aspects of
          the property.
        </Text>
      </View>
    </View>
  );
};

export default NewHampshire;
